module.exports = __webpack_public_path__ + "img/digitalSwitzerland.76389b0a.png";